// Generated by scripts/wizbuild.mjs.
import { NgModule, provideZonelessChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentApacheComponent } from './component.apache/component.apache.component';
import { ComponentCodeDiffComponent } from './component.code-diff/component.code-diff.component';
import { ComponentCodeEditorComponent } from './component.code-editor/component.code-editor.component';
import { ComponentConsoleComponent } from './component.console/component.console.component';
import { ComponentContainersComponent } from './component.containers/component.containers.component';
import { ComponentDashboardComponent } from './component.dashboard/component.dashboard.component';
import { ComponentFileBrowserComponent } from './component.file-browser/component.file-browser.component';
import { ComponentIconComponent } from './component.icon/component.icon.component';
import { ComponentResourceChartComponent } from './component.resource-chart/component.resource-chart.component';
import { ComponentTemplateInputEditorComponent } from './component.template-input-editor/component.template-input-editor.component';
import { ComponentTerminalComponent } from './component.terminal/component.terminal.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PageDomainsComponent } from './page.domains/page.domains.component';
import { PageImagesComponent } from './page.images/page.images.component';
import { PageMacrosComponent } from './page.macros/page.macros.component';
import { PageMacrosDetailComponent } from './page.macros.detail/page.macros.detail.component';
import { PageOperationsComponent } from './page.operations/page.operations.component';
import { PageOperationsDetailComponent } from './page.operations.detail/page.operations.detail.component';
import { PageReportsComponent } from './page.reports/page.reports.component';
import { PageSchedulesComponent } from './page.schedules/page.schedules.component';
import { PageServersComponent } from './page.servers/page.servers.component';
import { PageServersDetailComponent } from './page.servers.detail/page.servers.detail.component';
import { PageServicesComponent } from './page.services/page.services.component';
import { PageServicesDetailComponent } from './page.services.detail/page.services.detail.component';
import { PageSystemComponent } from './page.system/page.system.component';
import { PageTemplatesComponent } from './page.templates/page.templates.component';
import { PageTemplatesDetailComponent } from './page.templates.detail/page.templates.detail.component';

@NgModule({
  declarations: [
    AppComponent,
    ComponentApacheComponent,
    ComponentCodeDiffComponent,
    ComponentCodeEditorComponent,
    ComponentConsoleComponent,
    ComponentContainersComponent,
    ComponentDashboardComponent,
    ComponentFileBrowserComponent,
    ComponentIconComponent,
    ComponentResourceChartComponent,
    ComponentTemplateInputEditorComponent,
    ComponentTerminalComponent,
    LayoutEmptyComponent,
    LayoutSidebarComponent,
    PageAccessComponent,
    PageDashboardComponent,
    PageDomainsComponent,
    PageImagesComponent,
    PageMacrosComponent,
    PageMacrosDetailComponent,
    PageOperationsComponent,
    PageOperationsDetailComponent,
    PageReportsComponent,
    PageSchedulesComponent,
    PageServersComponent,
    PageServersDetailComponent,
    PageServicesComponent,
    PageServicesDetailComponent,
    PageSystemComponent,
    PageTemplatesComponent,
    PageTemplatesDetailComponent
  ],
  imports: [BrowserModule, FormsModule, AppRoutingModule],
  providers: [provideZonelessChangeDetection()],
  bootstrap: [AppComponent]
})
export class AppModule {}
